import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
// import { getServerEndpoint } from '../../utils/utils';
import { graphqlRequest } from '../../services/graphql-service';
import { CREATE_NEW_USER } from '../../config/queries';

// handle requests to send us an email
export const createUser = createAsyncThunk('graphql/createUser', async (signupData, { rejectWithValue }) => {
	// const url = `graphql/createUser`;
	try {
    const response = await graphqlRequest(CREATE_NEW_USER, signupData);
    if (!response.createUser) throw new Error("Failed to send");
    return await response.createUser;
  } catch (error) {
    return rejectWithValue(error.message);
  }
});


const userSlice = createSlice({
  name: "user",
  initialState: { user: null, loading: false },
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(createUser.fulfilled, (state, action) => {
        state.user = action.payload;
      })
      .addCase(createUser.rejected, (state, action) => {
        state.error = action.payload;
      });
  },
});

export const { logout } = userSlice.actions;
export default userSlice.reducer;